import { getNode } from '@formkit/core';

export function normalizeField(event, normalize, nodeGetter = null) {
  const node = (nodeGetter != null) ? nodeGetter(event.target.id, event.target) : getNode(event.target.id);
  if (node == null) {
    console.error('FormKit node not found; check that the following element has an ID and is a FormKit component:', event.target);
    return Promise.resolve();
  }
  const value = event.target.value;
  const normalizedValue = normalize(value);
  if (normalizedValue != null && normalizedValue !== value) {
    return node.input(normalizedValue);
  }
  return Promise.resolve()
}
